
// let setTimeToShow
let setTimeToHide

function hoverDropMenu () {
	// console.debug('23053')
	const menu = document.querySelectorAll('.ShenyunHeader--Nav > li')
	// const menu = query('#shenyun-header-nav > li')
	menu.forEach(item => {
		const dropDown = item.querySelector('.dropdown-wrapper')
		// if (dropDown) console.debug(dropDown)

		if (dropDown) {
			item.addEventListener('mouseenter', hoverAction.bind(this), false)
			item.addEventListener('mouseleave', leaveAction.bind(this), false)

			// dropDown.addEventListener('mouseenter', ReSetTimer.bind(this))
			// dropDown.addEventListener('mouseleave', leaveAction.bind(this))
		}
	})

}

function hoverAction (e) {
	const item = e.target
	item.classList.add('active')
	const dropDown = item.querySelector('.dropdown-wrapper')
	// setTimeToShow = setTimeout(() => {item.classList.add('active')}, 100)
	dropDown.addEventListener('animationend', hoverEndAction.bind(this, item))
}

function hoverEndAction (item, e) {
	// const dropDown = e.target
	item.classList.replace('active', 'dropdown-shown')
}

function leaveAction (e) {
	const timeOutValue = 100
	const item = e.target
	const dropDown = item.querySelector('.dropdown-wrapper')
	// setTimeToHide = setTimeout(() => {
	// item.classList.replace('dropdown-shown', 'leaveActive')
	item.setAttribute('class', 'leaveActive')
	// }, timeOutValue)
	dropDown.addEventListener('animationend', leaveEndAction.bind(this, item))
}

function leaveEndAction (item) {
	// const dropDown = e.target
	item.classList.remove('leaveActive')
}

// function ReSetTimer () {
// 	if (setTimeToHide) {
// 		clearTimeout(setTimeToHide)
// 		// console.debug('ReSetTimer')
// 		// setTimeToHide = 0
// 	}
// }

export default hoverDropMenu
